"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveCurrenciesFromMarket = void 0;
var markets_1 = require("../markets");
var currencies_1 = require("../currencies");
/** Resolve currencies from marketId
 * @param {Market} market - Market id
 * @returns {MarketCurrencies} Market Currencies
 */
function resolveCurrenciesFromMarket(market) {
    var _a;
    var marketDetails = markets_1.marketLookupMap[market];
    if (!marketDetails) {
        throw new Error("Market not found: ".concat(market));
    }
    var priority = [];
    var standard = [];
    for (var _i = 0, _b = marketDetails.currencies; _i < _b.length; _i++) {
        var currency = _b[_i];
        priority.push({
            code: currency,
            symbol: currencies_1.SYMBOLS[currency]
        });
    }
    var _loop_1 = function (currency) {
        if (priority.some(function (_a) {
            var code = _a.code;
            return code === currency;
        })) {
            return "continue";
        }
        if (currencies_1.HIDE_CURRENCY_UNLESS_PRIORITY.includes(currency)) {
            return "continue";
        }
        if (currencies_1.STANDARD_HIDDEN_CURRENCIES[currency]
            && ((_a = currencies_1.STANDARD_HIDDEN_CURRENCIES[currency]) === null || _a === void 0 ? void 0 : _a.includes(market)) !== true) {
            return "continue";
        }
        standard.push({
            code: currency,
            symbol: currencies_1.SYMBOLS[currency]
        });
    };
    for (var _c = 0, CURRENCIES_1 = currencies_1.CURRENCIES; _c < CURRENCIES_1.length; _c++) {
        var currency = CURRENCIES_1[_c];
        _loop_1(currency);
    }
    return { priority: priority, standard: standard };
}
exports.resolveCurrenciesFromMarket = resolveCurrenciesFromMarket;
